import type { OperationStatus } from "~/core/models/OperationStatus.enum";
import { computeOperationStatusesColor } from "~/modules/dtwin/utils/dtwinsListMetadataStatus";

export const computeIconClass = (
  dtwinOperationStatuses?: Record<string, OperationStatus>,
  overlayIcon?: string,
) => {
  let iconClass: string = `text-${computeOperationStatusesColor(dtwinOperationStatuses)}`;
  if (!overlayIcon) {
    iconClass = iconClass.concat(" default-icon");
  }
  return iconClass;
};
